import { render, staticRenderFns } from "./matching-car.vue?vue&type=template&id=74b74ac6&scoped=true"
import script from "./matching-car.vue?vue&type=script&lang=js"
export * from "./matching-car.vue?vue&type=script&lang=js"
import style0 from "./matching-car.vue?vue&type=style&index=0&id=74b74ac6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b74ac6",
  null
  
)

export default component.exports